export class PlantsIdRequest{
    plantId : number;
    plantName?: string;

      constructor(plantId : number, plantName?:string){
        this.plantId = plantId;
        this.plantName=plantName;
    }

}